export default __webpack_public_path__ + "static/media/adventure-bible-logo-schools.1e6deb66.png";